import styled from 'styled-components'

import sendButtonArrow from '../../../assets/REDESIGN_Assets/ChatBox/send-button-arrow.svg'

export const ChatBoxBox = styled.div`
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media only screen and (max-width: 600px) {
    height: 86vh;
  }
`
export const ChatBoxColumn = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  box-sizing: border-box;
  max-width: 50%;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.align ? props.align : 'center')};

  @media only screen and (max-width: 600px) {
    width: 100%;
    max-width: 100%;
  }
`
export const ChatBoxViewBox = styled.div`
  width: 60%;
  /* margin-top: 25%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 50%;
  margin-left: 10%;
  max-height: 90%;

  @media only screen and (max-width: 600px) {
    width: 95%;
    max-width: 95%;
    margin-left: 0%;
  }
`

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 100%;
  overflow-x: hidden;
  padding: 3% 5% 3% 3%;
  width: 90%;

  /* width */
  ::-webkit-scrollbar {
    width: 8px;
    box-sizing: border-box;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: white;
    border-radius: 4px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  scrollbar-color: transparent;

  scrollbar-width: 8px;
`

export const ChatSingleMessage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0% 0;
  padding: 3%;
  border-radius: 19px;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`

export const ChatSendButton = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #a1ff68;
  box-sizing: border-box;
  right: 8%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const InputContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
`
